import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import CookieBanner from "@/components/CookieBanner";
import Landing from "@/pages/Landing";
import Entregables from "@/pages/Entregables";
import EntregableDetalle from "@/pages/EntregableDetalle";
import Normativa from "@/pages/Normativa";
import Mapa from "@/pages/Mapa";
import Documentacion from "@/pages/Documentacion";
import Contacto from "@/pages/Contacto";
import PoliticaPrivacidad from "@/pages/PoliticaPrivacidad";
import PoliticaCookies from "@/pages/PoliticaCookies";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Landing />} />
            <Route path="entregables" element={<Entregables />} />
            <Route path="entregables/:wpId" element={<EntregableDetalle />} />
            <Route path="normativa" element={<Normativa />} />
            <Route path="mapa" element={<Mapa />} />
            <Route path="documentacion" element={<Documentacion />} />
            <Route path="contacto" element={<Contacto />} />
            <Route path="politica-privacidad" element={<PoliticaPrivacidad />} />
            <Route path="politica-cookies" element={<PoliticaCookies />} />
          </Route>
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
